import netpack from "./../../utils/netpack";
import actionConsts from "./../../constants/actions";
import urlConsts from "./../../constants/urls";
// import urlConsts from '../constants/urls';
import store from "./../../store/store";
import { incomingCallNotification } from "./../call";
import { incomingMeetingNotification } from "./../meeting";
import orderBy from "lodash/orderBy";

let timerCallBack = [];

export const scheduleMails = (response, dispatch, getState) => {
	// get mails from state
	let mailsList = store.getState().mails;
	let callList = store.getState().calls;
	let meetingList = store.getState().meetings;
	let timeData = getTimeData();

	// get all primary mails
	let primaryMailList = getPrimaryMailList(mailsList);
	let primaryCallList = getPrimaryMailList(callList);
	let primaryMeetingList = getPrimaryMailList(meetingList);

	let timeOutMailsList = getMailsWithTimeOut(mailsList);

	schedulePrimaryMails(primaryMailList, timeData);
	scheduleTimeoutMails(timeOutMailsList, timeData);

	if (primaryCallList && primaryCallList.length > 0) {
		schedulePrimaryCalls(primaryCallList, timeData);
	}
	if (primaryMeetingList && primaryMeetingList.length > 0) {
		schedulePrimaryMeetings(primaryMeetingList, timeData);
	}
};

// create a entry function for primary mail (recive primarymail array )

const schedulePrimaryMails = (primaryMailList, timeData) => {
	primaryMailList.map((mail, index) => {
		if (index === 0) {
			mail.isFirstMail = true;
		}
		let expectedAtTime = getExpectedTimeForAMail(
			timeData.totalTime,
			mail.expectedAt
		);
		scheduleIndividualPrimaryMail(mail, expectedAtTime, timeData);
	});
};

const scheduleIndividualPrimaryMail = (mail, expectedAtTime, timeData) => {
	let timeRemaining = calculateTimeRemaining(
		expectedAtTime,
		timeData.timeLeft
	);
	scheduleIndividualMail(mail.id, timeRemaining, expectedAtTime);
	checkForSecondaryMail(mail, timeData);
};
/////////////////////////////////////////////////////////////////////////////////////////////////////////

/*************** ADD PRIMARY MAILS  *********************/

export const scheduleIndividualMail = (
	mailId,
	timeRemaining,
	expectedAtTime
) => {
	if (timeRemaining > 0) {
		addTimerToScheduleMail(mailId, timeRemaining, expectedAtTime);
	} else {
		store.dispatch(dispatchMail({ mailId, expectedAtTime }));
	}
};

const addTimerToScheduleMail = (mailId, timeRemaining, expectedAtTime) => {
	let timer = setTimeout(() => {
		store.dispatch(dispatchMail({ mailId, expectedAtTime }));
	}, timeRemaining);
	timerCallBack.push({
		mailId: mailId,
		timer
	});
};

const dispatchMail = payload => ({
	type: actionConsts.ADD_SHOW_MAIL_FLAG,
	payload: payload
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////

/*************** ADD SECONDARY MAILS  *********************/

const scheduleSecondaryMail = (mailData, timeData) => {
	let mailList = store.getState().mails;
	let currentMail = mailList.find(mail => mail.id === mailData.mailId);

	let expectedAtTime = getExpectedAtTimeForSecondaryMail(
		mailData.actionTakenAt,
		currentMail.mailDelay
	);
	let timeRemaining = calculateTimeRemaining(
		expectedAtTime,
		timeData.timeLeft
	);

	if (currentMail.type === "call") {
		scheduleIndividualCall(currentMail, timeRemaining, expectedAtTime);
	} else if (currentMail.type === "meeting") {
		scheduleIndividualMeeting(currentMail, timeRemaining, expectedAtTime);
	} else {
		scheduleIndividualMail(mailData.mailId, timeRemaining, expectedAtTime);
	}
	checkForSecondaryMail(currentMail, timeData);
};

const checkForSecondaryMail = (mail, timeData) => {
	if (mail && mail.actionThread) {
		mail.actionThread.forEach(action => {
			if (action.type === "next_mail") {
				scheduleSecondaryMail(action, timeData);
			}
		});
	}
};

export const addReplyMailToThread = responseMail => {
	store.dispatch(viewSentMail(responseMail));
};

export const getNextMail = response => {
	if (response.nextMailId) {
		store.dispatch({
			type: actionConsts.GET_NEXT_MAIL,
			payload: response
		});

		let timeData = getTimeData();

		scheduleSecondaryMail(
			{
				actionTakenAt: response.actionTakenAt,
				mailId: response.nextMailId,
				type: "next_mail"
			},
			timeData
		);
	}
};

const viewSentMail = payload => ({
	type: actionConsts.VIEW_SENT_MAIL,
	payload: payload
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////

/* ******************** SCHEDULING CALLS ****************************************** */

const schedulePrimaryCalls = (primaryCallList, timeData) => {
	primaryCallList.map(call => {
		let expectedAtTime = getExpectedTimeForAMail(
			timeData.totalTime,
			call.expectedAt
		);
		let timeRemaining = calculateTimeRemaining(
			expectedAtTime,
			timeData.timeLeft
		);
		scheduleIndividualCall(call, timeRemaining, expectedAtTime);
	});
};

const scheduleIndividualCall = (call, timeRemaining, expectedAtTime) => {
	if (!checkCallTerminatedFlag(call)) {
		if (timeRemaining >= 0) {
			addTimerToScheduleCall(call, timeRemaining, expectedAtTime);
		} else {
			if (!checkIfVoiceMailIsPresent(call)) {
				store.dispatch(incomingCallNotification());
			}
			store.dispatch(
				dispatchCall({ call, expectedAtTime, type: "call" })
			);
		}
	}
	// store.dispatch(dispatchCall({ call, expectedAtTime, saveCall: false }));
};

const addTimerToScheduleCall = (call, timeRemaining, expectedAtTime) => {
	let timer = setTimeout(() => {
		store.dispatch(incomingCallNotification());
		store.dispatch(dispatchCall({ call, expectedAtTime, type: "call" }));
	}, timeRemaining);

	timerCallBack.push({
		callId: call.id,
		timer
	});
};

const dispatchCall = payload => ({
	type: actionConsts.ADD_SHOW_CALL_FLAG,
	payload: payload
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////

/* ******************** SCHEDULING MEETINGS ****************************************** */

const schedulePrimaryMeetings = (primaryMeetingList, timeData) => {
	primaryMeetingList.map(meeting => {
		let expectedAtTime = getExpectedTimeForAMail(
			timeData.totalTime,
			meeting.expectedAt
		);
		let timeRemaining = calculateTimeRemaining(
			expectedAtTime,
			timeData.timeLeft
		);
		scheduleIndividualMeeting(meeting, timeRemaining, expectedAtTime);
	});
};

const scheduleIndividualMeeting = (meeting, timeRemaining, expectedAtTime) => {
	if (!checkCallTerminatedFlag(meeting)) {
		if (timeRemaining > 0) {
			if (Math.floor(timeRemaining / 60000) > 0) {
				showMeeetingNotification(timeRemaining);
			}
			addTimerToScheduleMeeting(meeting, timeRemaining, expectedAtTime);
		} else {
			store.dispatch(incomingMeetingNotification());
			store.dispatch(
				dispatchMeeting({ meeting, expectedAtTime, type: "meeting" })
			);
		}
	}
	// store.dispatch(dispatchMeeting({ meeting, expectedAtTime, saveCall: false }));
};

const addTimerToScheduleMeeting = (meeting, timeRemaining, expectedAtTime) => {
	let timer = setTimeout(() => {
		store.dispatch(incomingMeetingNotification());
		store.dispatch(
			dispatchMeeting({ meeting, expectedAtTime, type: "meeting" })
		);
	}, timeRemaining);

	timerCallBack.push({
		meetingId: meeting.id,
		timer
	});
};

const showMeeetingNotification = timeRemaining => {
	if (timeRemaining / 1000 > 300) {
		let timer = setTimeout(() => {
			store.dispatch(dispatchMeetingNotification(timeRemaining));
		}, timeRemaining - 300 * 1000);
		timerCallBack.push({
			notifId: Math.random(),
			timer
		});
	} else {
		store.dispatch(dispatchMeetingNotification(timeRemaining));
	}
};

export const hideMeetingNotification = () => {
	store.dispatch({
		type: actionConsts.HIDE_MEETING_NOTIFICATION,
		payload: false
	});
};

const dispatchMeetingNotification = meetingTimeLeft => ({
	type: actionConsts.SHOW_MEETING_NOTIFICATION,
	payload: meetingTimeLeft
});

const dispatchMeeting = payload => ({
	type: actionConsts.ADD_SHOW_MEETING_FLAG,
	payload: payload
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////

/*************** MAIL ACTIONS FUNCTIONs *********************/

//Timeout mails function
const scheduleTimeoutMails = (mailList, timeData) => {
	mailList.map(mail => {
		let mailTimeoutAt = getExpectedTimeForAMail(
			timeData.totalTime,
			mail.timeoutAt
		);

		//at the end of timeout, if the mail does not have a reply, then add next mail forcibly
		let timeRemaining = calculateTimeRemaining(
			mailTimeoutAt,
			timeData.timeLeft
		);
		if (timeRemaining > 0) {
			addTimeoutTimer(mail, timeRemaining, timeData);
		} else {
			dispatchTimeoutApi(mail, timeData);
		}
	});
};

const addTimeoutTimer = (mail, timeRemaining, timeData) => {
	let timer = setTimeout(() => {
		dispatchTimeoutApi(mail, timeData);
	}, timeRemaining);

	timerCallBack.push({
		mailId: mail.id,
		timer
	});
};

const dispatchTimeoutApi = (mail, timeData) => {
	// This was not working bcos of not getting the updated mail data from the state. Used to work on refresh
	let mailFromReducer = store
		.getState()
		.mails.find(item => (item.id === mail.id));

	if (!doesMailHaveAReply(mailFromReducer.actionThread) && isShownAction(mailFromReducer.actionThread)) {
		if (!isMailTimeOutFlagPresent(mailFromReducer.actionThread)) {
			//api call
			let postBody = {
				primaryMailId: mailFromReducer.id,
				actionTakenAt: timeData.timeLeft
			};
			const options = {
				body: JSON.stringify(postBody)
			};

			netpack(urlConsts.MAIL_TIME_OUT)
				.post(options)
				.then(response => {
					if (response.success) {
						let timeData = getTimeData();
						scheduleSecondaryMail(
							{
								actionTakenAt: timeData.timeLeft,
								mailId: response.nextMailId,
								type: "next_mail"
							},
							timeData
						);
					}
				})
				.catch(frontendError => {
					console.log(frontendError);
				});
		}
	}
};

/////////////////////////////////////////////////////////////////////////////////////////////////////////

/*************** MAIL ACTIONS FUNCTIONs *********************/

export const addMailReadFlag = payload => {
	let postBody = {
		primaryMailId: payload,
		responseMailId: payload
	};
	const options = {
		body: JSON.stringify(postBody)
	};

	//To stop mail read request in tutorial mode
	if (!window.location.href.includes("tutorial")) {
		netpack(urlConsts.MAIL_READ)
			.post(options)
			.then(response => {
				if (response.success) {
					store.dispatch({
						type: actionConsts.ADD_MAIL_READ_FLAG,
						payload: payload
					});
				}
			})
			.catch(frontendError => {
				console.log(frontendError);
			});
	}
};

export const addMailStarredFlag = payload => {
	let postBody = {
		primaryMailId: payload,
		responseMailId: payload,
		status: true
	};
	const options = {
		body: JSON.stringify(postBody)
	};
	netpack(urlConsts.MAIL_STARRED)
		.post(options)
		.then(response => {
			if (response.success) {
				store.dispatch({
					type: actionConsts.ADD_MAIL_STARRED_FLAG,
					payload: payload
				});
			}
		})
		.catch(frontendError => {
			console.log(frontendError);
		});
};

export const removeMailStarredFlag = payload => {
	let postBody = {
		primaryMailId: payload,
		responseMailId: payload,
		status: false
	};
	const options = {
		body: JSON.stringify(postBody)
	};
	netpack(urlConsts.MAIL_STARRED)
		.post(options)
		.then(response => {
			if (response.success) {
				store.dispatch({
					type: actionConsts.REMOVE_MAIL_STARRED_FLAG,
					payload: payload
				});
			}
		})
		.catch(frontendError => {
			console.log(frontendError);
		});
};

export const saveMailAsDraft = payload => {
	store.dispatch({
		type: actionConsts.SAVE_DRAFT,
		payload: payload
	});
};

/////////////////////////////////////////////////////////////////////////////////////////////////////////

/*************** UTILITIES FUNCTION *********************/

const calculateTimeRemaining = (expectedAtTime, timeLeft) => {
	return (timeLeft - expectedAtTime) * 1000;
};

const getExpectedTimeForAMail = (totalTime, expectedAt) => {
	return Math.floor((totalTime * (100 - expectedAt)) / 100);
};

const getExpectedAtTimeForSecondaryMail = (actionTakenAt, delay) => {
	let timeData = getTimeData();
	return actionTakenAt - (delay * timeData.totalTime) / 100;
};

const checkCallTerminatedFlag = call => {
	return call.actionThread.some(action => action.type === "call_terminated");
};

const checkIfVoiceMailIsPresent = call => {
	return call.actionThread.some(action => action.type === "next_mail");
};

const getPrimaryMailList = mailsList => {
	return orderBy(
		mailsList.filter(mail => mail.isPrimary && mail.isInitDisplay),
		["expectedAt"],
		["asc"]
	);
};

const getMailsWithTimeOut = mails => {
	return mails.filter(mail => mail.timeoutAt > 0);
};

const isShownAction = actionThread => {
	return actionThread.find(action => action.type === "isShown");
};

const doesMailHaveAReply = actionThread => {
	return actionThread.find(action => action.type === "compose");
};

const isMailTimeOutFlagPresent = actionThread => {
	return actionThread.find(
		action => action.type === "is_mail_timeout_reached"
	);
};

export const getTimeData = () => {
	//get time from state
	return store.getState().timeData;
};

export const setCurrentMailIndex = id => {
	const { mails, match, mailThreads } = store.getState();

	const isPrimaryMailReady = mail => {
		return (
			mail.isPrimary &&
			mail.actionThread &&
			isShownAction(mail.actionThread) &&
			mail.type !== "call" &&
			mail.type !== "meeting"
		);
	};

	let tempArray = mails.filter(mail => isPrimaryMailReady(mail));
	tempArray.map(mail => {
		let thread = mailThreads.find(mailThread => mailThread[0] === mail.id);
		let timeData = getTimeData();

		if (thread) {
			let lastMail = mails.find(
				threadMail => threadMail.id === thread[thread.length - 1]
			);
			if (!isShownAction(lastMail.actionThread)) {
				lastMail = mails.find(
					threadMail => threadMail.id === thread[thread.length - 2]
				);
			}
			let displayTime = lastMail.receivedAtTime - timeData.timeLeft;
			if (displayTime > 0) {
				mail.displayTime = displayTime;
			} else {
				mail.displayTime = 0;
			}
			mail.lastMail = lastMail;
		} else {
			let displayTime = mail.receivedAtTime - timeData.timeLeft;
			if (displayTime > 0) {
				mail.displayTime = displayTime;
			} else {
				mail.displayTime = 0;
			}
			mail.lastMail = mail;
		}
		return mail;
	});

	let sortedArray = orderBy(
		tempArray,
		["displayTime", "id"],
		["asc", "desc"]
	);

	let index = sortedArray.findIndex(mail => mail.id === id);

	store.dispatch({
		type: actionConsts.SET_CURRENT_MAIL_INDEX,
		payload: index
	});
};



// WEBPACK FOOTER //
// /src/actions/mail/mailScheduler.js